import { ObservationsMgr } from "../../observations/manager"
import { SelectedFieldAction, SelectedFieldObservation } from "../../observations/types"

interface Props {

    mgr: ObservationsMgr

    obs: SelectedFieldObservation
    action?: SelectedFieldAction


}

export function SaveFavorite({ obs, action, mgr }: Props) {

    if (!obs) {
        return null
    }

    const isAction = !!action

    const id = action ? action.actionId : obs.observationId
    const text = action ? action.text : obs.text

    const isUserDefined = isAction
        ? mgr.isUserDefined(obs.text, text)
        : mgr.isUserDefined(text, undefined)

    const canSave = (!id) && text && (text.length >= mgr.minimumLength) && (!isUserDefined)

    const canRemove = isUserDefined

    const save = (text: string, save: boolean) => {
        mgr.save({
            observation: isAction ? obs.text : text,
            action: isAction ? text : undefined,
            save
        })
    }

    return <>

        {canSave &&
            <div>
                <button type="button" className="btn btn-icon" onClick={() => save(text, true)} title="Save to favourites">
                    <i className="far fa-star"></i>
                </button>
            </div>
        }

        {canRemove &&
            <div>
                <button type="button" className="btn btn-icon transparent text-highlight" onClick={() => save(text, false)} title="Remove from favourites">
                    <i className="fas fa-star"></i>
                </button>
            </div>
        }

    </>

}
